"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripHTML;

require("./String.prototype.replaceAll");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var HTML_TAG_REGEX = /<\/?[a-z][a-z0-9]*[^<>]*>/gi; // @see https://regex101.com/library/aJ9hT9

var HTML_ENTITY_REGEX = /&(?:[a-z\d]+|#\d+|#x[a-f\d]+);/gi; // @see https://regex101.com/library/kW6eU2

/**
 * Strips HTML tags, so only raw text is returned.
 * @param {string} string - stringified HTML content
 * @returns {string}
 */

function stripHTML(string) {
  if (!string) {
    return '';
  }

  if (typeof string !== 'string') {
    throw new Error("Expected string, but got ".concat(_typeof(string)));
  }

  return string.replaceAll(HTML_TAG_REGEX, '').replaceAll(HTML_ENTITY_REGEX, '');
}

//# sourceMappingURL=index.js.map